
import { mapState } from 'vuex'
import utils from '@/components/tools/utils'

export default {
  components: {},
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('customer', { hasAnyAds: 'hasAnyAds', merchant: 'merchant' }),
    ...mapState('upload', {
      product: 'product'
    }),

    buttonText () {
      return this.section?.buttonText
    },
    isMerchant () {
      return typeof this.merchant?.merchantId === 'number'
    },
    justLink () {
      return this.section?.justLink === true
    },
    linkTo () {
      if (this.section?.type === 'goHome') {
        return this.localePath({ name: 'index' })
      } else if (this.section?.type === 'goToAnyLink' && this.section?.anyLink) {
        return this.section?.anyLink
      } else {
        return this.localePath({ name: 'index' })
      }
    }
  },
  methods: {
    async clickButton () {
      if (this.section?.type === 'registerOrEditAd') {
        await this.registerOrEditAd()
      } else if (this.section?.type === 'scrollToTop') {
        await this.$vuetify.goTo(0)
      } else if (this.section?.type === 'goToAdIntake') {
        await this.gotToAdIntake()
      } else if (this.section?.type === 'goToAnyLink' && this.section?.anyLink) {
        // eslint-disable-next-line no-unused-expressions
        // window.open(this.section?.anyLink, '_blank') ...open any link using vue router
        await this.$router.push(this.section?.anyLink)
      } else {
        const routeName = utils.newAdOrMyVehiclesRoute(this.hasAnyAds, this.isMerchant)

        await this.$router.push(this.localePath({ name: routeName }))
      }
    },

    async registerOrEditAd () {
      if (this.$auth.loggedIn) {
        if (this.product.entityId) {
          const productType = this.product.productType

          const step = utils.getStepForAdInEditing(this.product)

          await this.$router.push(
            this.localePath({
              name: `ad-edit-${productType}-${step}-id`,
              params: { id: this.product.entityId }
            })
          )
        } else {
          const routeName = utils.newAdOrMyVehiclesRoute(this.hasAnyAds, this.isMerchant)
          await this.$router.push(this.localePath({ name: routeName }))
        }
      } else {
        await this.signUp()
      }
    },
    async gotToAdIntake () {
      if (this.product.entityId) {
        const { productType, entityId } = this.product

        await this.$router.push(this.localePath({
          name: `ad-edit-${productType}-profile-id`,
          params: { id: entityId }
        }))
      } else {
        const routeName = utils.newAdOrMyVehiclesRoute(this.hasAnyAds, this.isMerchant)
        await this.$router.push(this.localePath({ name: routeName }))
      }
    },

    async signUp () {
      const step = utils.getStepForAdInEditing(this.product)
      const productType = this.product.productType
      const localePath = {
        name: `ad-edit-${productType}-${step}-id`,
        params: { id: this.product.entityId }
      }

      await utils.addRedirectRouteAndSignUp(this, undefined, localePath)
    }
  }
}
